/** Base path when Spacebook is embedded in the portfolio app */
export const BOOKING_BASE = "/demo/booking";
